import type { InputHTMLAttributes } from 'react'

import clsx from 'clsx'

import css from './Radio.module.scss'

export const Radio = ({
	className,
	...props
}: InputHTMLAttributes<HTMLInputElement>) => (
	<input className={clsx(className, css.input)} type='radio' {...props} />
)
